import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(--allie-spacing-4xl) 0;
  gap: var(--allie-spacing-xl);
  width: 100%;
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--allie-color-neutral-0);
  border: 1px solid var(--allie-color-neutral-20);
  border-radius: var(--allie-radius-full);
  padding: var(--allie-spacing-lg);
  width: 56px;
  height: 56px;
  box-sizing: border-box;
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: var(--allie-spacing-xs);
  max-width: 356px;
`;
